import UserTareaService from "@/api/services/tarea/UserTareaService"
import Vue from "vue"

const state = () => ({
    tareas: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "fecha_creacion",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    USER_TAREAS: state => {
        return state.tareas
    },
    USER_TAREAS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_USER_TAREAS: (state, payload) => {
        state.tareas = payload
    },

    SET_USER_TAREAS_PAG: (state, payload) => {
        state.pagination = payload
    },

    TOOGLE_STATUS_TAREA: (state, payload) => {
        let taskIndex = state.tareas.findIndex(el => el.id === payload.task_id)
        let userIndex = state.tareas[taskIndex].users.findIndex(el => el.user_id === payload.user_id)

        Object.entries(payload).forEach(([key, value]) => Vue.set(state.tareas[taskIndex].users[userIndex], key, value))
    }
}

const actions = {
    LOAD_USER_TAREAS: async ({ commit, state }, { currentUser, filter, tareaEstado, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }

            if (tareaEstado === "5") {
                customfilter = `fecha_creacion=${new Date().toISOString().substr(0, 10)}`
            }

            if (tareaEstado === "7") {
                customfilter = `fecha_cumplimiento=${new Date().toISOString().substr(0, 10)}`
            }

            if (tareaEstado === "8") {
                customfilter = `cumplida=1&fecha_cumplimiento=${new Date().toISOString().substr(0, 10)}`
            }

            let { data, status, headers } = await UserTareaService.get({
                currentUser,
                filter,
                customfilter,
                tareaEstado,
                ...pagination
            })
            if (status === 200) {
                commit("SET_USER_TAREAS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las tareas, inténtelo nuevamente"
            })
        }
    },

    TOOGLE_STATUS_USER_TAREA: async ({ commit }, payload) => {
        try {
            let { data, status } = await UserTareaService.toogle_status(payload)
            if (status === 200) {
                commit("TOOGLE_STATUS_TAREA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "Se ha modificado satisfactoriamente el estado de la tarea"
                })
                return data
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el estado de la tarea, inténtelo nuevamente"
                })
            }
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
